import React from 'react';
import "./certificats.css"
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';

import IMG1 from "../../assets/certificats/lablabai.jpg";
import IMG2 from "../../assets/certificats/python_dev.jpg";
import IMG3 from "../../assets/certificats/javascript.jpg"

const credentials = [
  {
    title: "2nd Place Winner in Benin Multimodal AI Hackaton",
    issuer: "lablab.ai",
    date: "2024",
    image: IMG1
  },
  {
    title: "Python Developer",
    issuer: "Sololearn",
    date: "2024",
    image: IMG2
  },
  {
    title: "Javascript",
    issuer: "Sololearn",
    date: "2022",
    image: IMG3
  },
  // Add more certifications as needed
];

const Certificats = () => {
  return (
    <section id="licenses-certifications">
      <h5>Professional Qualifications</h5>
      <h2>Licenses & Certifications</h2>
      <Swiper
        className="container licenses-certifications-container"
        modules={[Pagination]}
        pagination={{ clickable: true }}
        spaceBetween={40}
        slidesPerView={1}
      >
        {credentials.map(({ title, issuer, date, image }, index) => (
          <SwiperSlide key={index} className="credential">
            <div className="credential-image">
              <img src={image} alt={issuer} />
            </div>
            <h3 className="credential-title">{title}</h3>
            <h4 className="credential-issuer">{issuer}</h4>
            
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Certificats;